/**
 * Textos de les millores de Compres (`es`): ajunta els fitxers de cada tall. Cablejat a `es.ts` amb un sol
 * `...compresEs`; així cada tall edita només el seu fitxer.
 */

import { estatsEs } from './estats.es.js';
import { filtresEs } from './filtres.es.js';
import { devolucionsEs } from './devolucions.es.js';

export const compresEs = {
  ...estatsEs,
  ...filtresEs,
  ...devolucionsEs,
} as const;
